import { useState } from 'react';

// Add table renderers to table configuration as an alternative to declare those
// renderers globally in the plugin
const computeConfiguration = (cmp, { renderers, editors, model }) => {
  const modelCfg = Object.assign({}, cmp.configuration && cmp.configuration.model || {
    readOnly: true,
    canCheck: false,
    canSelect: true,
    canCreate: false,
    canDelete: false,
  }, model);
  const editorsByName = {};
  if (editors) {
    editors.forEach((editor) => { editorsByName[editor.name] = editor; });
  }

  const computedConfig = (Array.isArray(cmp) ? cmp : [cmp]).map(c => ({
    ...c,
    configuration: {
      ...c.configuration,
      model: modelCfg,
      table: {
        ...c.configuration.table,
        editors: editors && editorsByName,
        columns: c.configuration.table.columns.map((col) => {
          const renderer = renderers && (renderers[col.label] || renderers[col.name]);
          if (renderer) {
            return { ...col, valueRenderer: { component: renderer, valueOnly: true } };
          }
          return col;
        }),
      },
    },
  }));
  return Array.isArray(cmp) ? computedConfig : computedConfig[0];
};

const useTablePanelConfiguration = (component, options = {}) => {
  const [config] = useState(() => computeConfiguration(component, options));
  return config;
};

export default useTablePanelConfiguration;
